/**
 * Sync status enum for the synchronization between Skrift (DB) and WorkOS.
 */
export enum WorkOSSyncStatus {
  SYNCED = "SYNCED",
  FAILED = "FAILED",
  PENDING = "PENDING",
}
